<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="getTitle" class="common-header" style="box-shadow: none;">
        <mt-button slot="left" icon="back" @click="goBack"></mt-button>
        <mt-button v-if="!isAddMode" style="color: #E7010C;font-weight: 600;" slot="right"
          @click="onDelete(address_id)">
          {{ $t('Delete') }}
        </mt-button>
      </mt-header>
    </div>
    <!-- <div v-if="config && config.chain_isuse == 1" class="notice">
      <span>使用代收点</span>
      <div class="common-btn ds-button-small btn" @click="goChain"><span>使用</span></div>
    </div> -->
    <div class="main-content">
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">{{ $t('name') }}</span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter')" v-model="address_info.address_realname" />
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">{{ $t('phone') }}</span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter')" v-model="address_info.address_mob_phone" />
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :is-link="true" :show-border="true">
        <span>{{ $t('district') }}</span>
        <div class="field-line-right" slot="right" @click="onRegion">
          <!-- <span>{{ address_info.area_info }}</span> -->
          <input class="field-input" v-model="address_info.area_info" readonly />
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :show-border="true">
        <span class="field-name">{{ $t('address') }}</span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter')" v-model="address_info.address_detail" />
        </div>
      </flex-line>
      <flex-line :show-border="true">
        <span class="line-name">{{ $t('default address') }}</span>
        <div slot="right">
          <mt-switch v-model="address_info.address_is_default"></mt-switch>
        </div>
      </flex-line>

      <div class="pt-10 pb-10">
        <div class="common-btn ds-button-large" @click="submit">{{ getSumitTitle }}</div>
      </div>
    </div>
    <region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>

    <!--&lt;!&ndash;地图选点&ndash;&gt;-->
    <!--<mt-popup v-model="popMap" position="right" class="common-popup-wrapper">-->
    <!--<div class="common-header-wrap">-->
    <!--<mt-header title="定位" class="common-header">-->
    <!--<mt-button slot="left" icon="back" @click="popMap=false"></mt-button>-->
    <!--</mt-header>-->
    <!--</div>-->
    <!--<div class="common-popup-content">-->
    <!--<map-select ref="map_select" :longitude="address_info.address_longitude" :latitude="address_info.address_latitude" @setPosition="setPosition"></map-select>-->
    <!--</div>-->
    <!--</mt-popup>-->
  </div>
</template>

<script>
import { getPointByAddress } from '../../../util/bmap'
import { mapState, mapMutations, mapActions } from 'vuex'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import RegionPicker from '../../../components/RegionPicker'
import MapSelect from '../../../components/MapSelect'
import { getAddressInfo, addAddress, delAddress, editAddress } from '../../../api/memberAddress'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
    RegionPicker,
    // MapSelect
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
    isAddMode() {
      let mode = this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle() {
      if (this.isAddMode) {
        return this.$t('Add address')
      } else {
        return this.$t('Edit address')
      }
    },
    getSumitTitle() {
      let isFromCheckout = this.$route.query.isFromCheckout
      if (isFromCheckout) {
        return this.$t('save and use')
      } else {
        return this.$t('save')
      }
    }
  },
  data() {
    return {
      popMap: false,
      address_id: 0,
      goBackLevel: this.$route.query.goBackLevel ? this.$route.query.goBackLevel : -1,
      address_info: {
        address_realname: '',
        address_mob_phone: '',
        address_detail: '',
        address_is_default: true,
        area_info: this.$t('Please select a region'),
        city_id: 0,
        area_id: 0,
        address_longitude: 0,
        address_latitude: 0
      }
    }
  },
  created: function () {
    this.fetchConfig()
    if (!this.isAddMode) {
      this.address_id = this.$route.query.address_id
      getAddressInfo(this.address_id).then(res => {
        this.address_info.address_realname = res.result.address_info.address_realname
        this.address_info.address_mob_phone = res.result.address_info.address_mob_phone
        this.address_info.address_detail = res.result.address_info.address_detail
        this.address_info.area_info = res.result.address_info.area_info
        this.address_info.city_id = res.result.address_info.city_id
        this.address_info.area_id = res.result.address_info.area_id
        this.address_info.address_longitude = res.result.address_info.address_longitude
        this.address_info.address_latitude = res.result.address_info.address_latitude
        if (res.result.address_info.address_is_default === '1') {
          this.address_info.address_is_default = true
        } else {
          this.address_info.address_is_default = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    onDelete(addressId) {
      let that = this
      MessageBox({
        title: that.$t('MessageBox.Tips'),
        message: that.$t('MessageBox.delete.address'),
        confirmButtonText: that.$t('MessageBox.Confirm'),
        cancelButtonText: that.$t('MessageBox.Cancel'),
        showCancelButton: true
      }).then(action => {
        if (action == 'confirm') {
          Indicator.open()
          delAddress(addressId).then(
            (response) => {
              this.updateSelectedAddress()
              Indicator.close()
            }, (error) => {
              Indicator.close()
              Toast(error.message)
            })
        }
      });
    },
    goChain() {
      this.$router.push({ name: 'MemberChainForm', query: { action: 'add' } })
    },
    goBack() {
      this.$router.go(this.goBackLevel)
    },
    getPosition() {
      getPointByAddress(this.address_info.area_info + this.address_info.address_detail).then(res => {
        if (res.result.location) {
          this.address_info.address_longitude = res.result.location.lng
          this.address_info.address_latitude = res.result.location.lat
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition(lat, lng, name) {
      this.popMap = false
      this.address_info.address_detail = name
      this.address_info.address_longitude = lng
      this.address_info.address_latitude = lat
    },
    submit() {
      if (this.address_info.address_realname === '' || this.address_info.address_realname.length === 0) {
        Toast(this.$t('Please fill in the recipient name'));
        return;
      }
      if (this.address_info.address_realname.length < 2 || this.address_info.address_realname.length > 15) {
        Toast(this.$t('Name must be 2-15 characters'));
        return;
      }
      if (this.address_info.address_mob_phone === '' || this.address_info.address_mob_phone.length === 0) {
        Toast(this.$t('Please fill in the mobile phone number'));
        return;
      }
      if (this.address_info.area_id === 0 || this.address_info.area_id === undefined) {
        Toast(this.$t('Please select your location'));
        return;
      }
      if (this.address_info.address_detail === '' || this.address_info.address_detail.length === 0) {
        Toast(this.$t('Please fill in the detailed address'));
        return;
      }
      if (this.address_info.address_longitude === 0 || this.address_info.address_latitude === 0) {
        // Toast('请在地图选址')
      }

      if (this.isAddMode) {
        Indicator.open()
        addAddress(this.address_info).then(
          (response) => {
            Indicator.close()
            this.updateSelectedAddress()
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editAddress(this.address_info, this.address_id).then(
          (response) => {
            Indicator.close()
            this.updateSelectedAddress()
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    },
    onRegion(picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm(values) {
      this.address_info.area_info = this.getRegionStr(values)

      this.address_info.area_id = values[2].area_id
      this.address_info.city_id = values[1].area_id
    },
    getRegionStr(values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    updateSelectedAddress() {
      let isFromCheckout = this.$route.query.isFromCheckout
      if (isFromCheckout) {
        this.$router.go(this.goBackLevel)
      } else {
        this.goBack()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-button-large {
  width: 80%;
  position: relative;
  // bottom: 2rem;
  // left: 50%;
  // transform: translateX(-50%);
  background: #E7010C;
}

.container {
  
  background: #fff;
}

.main-content {
  background: #fff;
  padding: 0 $pageSpace;

  .input-wrapper {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    background-color: #fff;
    // height: 2.2rem;
    padding-left: 0.5rem;

    flex-direction: column;
    align-items: flex-start;
    margin: .6rem 0;

    ::v-deep(.right) {
      background: #FAFAFA;
    }

    .field-name {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      margin: .5rem 0;
    }

    input {
      flex: 1;
      font-size: $subFontSize;
      flex: 1;
      width: 14.5rem;
      text-align: left !important;
      // border: 1px solid #cccccc;
      padding: .9rem;
      border-radius: .4rem;
      background: #FAFAFA;
      border-radius: 5px 5px 5px 5px;
    }

    .bottom-input {
      border-bottom-width: 0;
    }
  }

}

.right-arrow {
  transform: rotate(-90deg);
  color: #ddd;
  font-size: $fontSize;
  display: inline-block;
}

.input-wrap {
  position: relative;

  i {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 2.4rem;
    display: block;
    width: 2rem;
    text-align: center;
    font-size: $h1
  }
}

.notice {
  font-size: $subFontSize;
  padding: .5rem;
  background: #FCF8E3;
  color: #C09853;
  line-height: 1.65rem;

  .red {
    color: #F00
  }

  .btn {
    float: right
  }
}

::v-deep(.mint-switch-core) {
  border-color: #E7010C !important;
  background-color: #E7010C !important;
}
</style>
